<div class="forgot-email-container">
  <div class="forgot-email-box">
    <div class="logo-header">
      <img [src]="logoPath" alt="Nevada Department of Education Logo" class="nde-logo">
    </div>
    <hr class="horizontal-line" />
    <div class="content">
      <div class="heading-content">
        <h2 class="title"> {{ mode === '2fa' ? 'Verify Your Identity' : 'Find Your Account' }}</h2>
        <p class="subtitle">{{mode === '2fa'? 'For your security, we need to confirm it’s you. Select a method to
          receive your one-time verification code.': 'Choose how you’d like to receive your one-time verification
          code.'}}</p>
        <!-- <p class="subtitle">Select a method to receive your one-time verification code.</p> -->
      </div>
      <form [formGroup]="findaccount">
        <div class="method-options">
          <label class="option" [ngClass]="{'selected': findaccount.get('method').value === 'email'}">
            <input type="radio" formControlName="method" value="email" />
            <div class="radio-button">
              <div class="radio-inner"></div>
            </div>
            <div class="option-label-wrapper" *ngIf="email && mode === '2fa'">
              <span class="option-label">Mail</span>
              <span class="masked-value">{{ maskEmail(email) }}</span>
            </div>
            <span *ngIf="mode !== '2fa'" class="option-label">Email</span>
          </label>
          <label class="option" [ngClass]="{'selected': findaccount.get('method').value === 'phone'}">
            <input type="radio" formControlName="method" value="phone" />
            <div class="radio-button">
              <div class="radio-inner"></div>
            </div>
            <span class="option-label">Phone Number</span>
            <div *ngIf="phone && mode === '2fa'" class="masked-value">
              {{ maskPhone(phone) }}
            </div>
          </label>
        </div>
        <div class="action-buttons">
          <ng-container *ngIf="mode === '2fa'; else forgotButtons">
            <button type="button" class="send-button" (click)="send2faOtp()">
              <span class="button-text">Send Code</span>
            </button>
          </ng-container>
          <ng-template #forgotButtons>
            <button type="button" class="cstmBtn cancel-btn" id="btn_find-account_cancel" (click)="onCancel()">
              <span class="button-text">Cancel</span>
            </button>
            <button type="button" class="cstmBtn cta-button" id="btn_find-account_submit" (click)="onContinue()">
              <span class="button-text">Continue</span>
            </button>
          </ng-template>
        </div>
      </form>
    </div>
  </div>
</div>